import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as display from '../../../../../../../../display'
import { Store } from '../../../store'

/**
 * Body of modal used to edit org chart nodes
 */
@ngCore.Component({
  imports: [
    ds.input.text.Component,
    ds.input.textArea.Component,
    ds.input.select.single.Component,
    display.value.Component,
  ],
  selector: 'atn-summit-org-chart-node-panel-skills-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  private readonly _store = ngCore.inject(Store)

  /** TODO */
  public readonly skillsSg = ngCore.computed(
    (chartId = this._store.chartIdSg()) =>
      chartId &&
      this._store.treeEditorFeature.selectors.getSkills({ chartId }).asSignal(),
  )
}
